import { render, staticRenderFns } from "./WFormX.vue?vue&type=template&id=27916094&"
import script from "./WFormX.vue?vue&type=script&lang=ts&"
export * from "./WFormX.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports